var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DefaultHeader'),_c('v-main',[_c('router-view')],1),_c('DefaultFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }